import { selectAssignment } from '@redux/experiments/selectors/index';
import type { State } from 'types/redux';

export const storefrontCompletionPenaltySelector = (state: State) => {
	return selectAssignment(state, ['storefrontCompletionPenalty']);
};

/** @knipignore experiment - remove when used */
export const isStorefrontCompletionPenaltyControl = (state: State) => {
	const assignment = storefrontCompletionPenaltySelector(state);
	return assignment === 'control';
};

/** @knipignore experiment - remove when used */
export const isStorefrontCompletionPenaltyVariant1 = (state: State) => {
	const assignment = storefrontCompletionPenaltySelector(state);
	return assignment === 'variant1';
};
